"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnouncementCategory = void 0;
var AnnouncementCategory;
(function (AnnouncementCategory) {
    AnnouncementCategory["Green"] = "green";
    AnnouncementCategory["Orange"] = "orange";
    AnnouncementCategory["Red"] = "red";
})(AnnouncementCategory = exports.AnnouncementCategory || (exports.AnnouncementCategory = {}));
//# sourceMappingURL=announcement-category.js.map